// extracted by mini-css-extract-plugin
export default {"container":"src-components-ClickableContainer-css-module__container--+wvGi"};